import { format, parseISO } from 'date-fns'
import { de } from 'date-fns/locale'
import type { Menu } from '@/api/types'

/** A daily menu is named by its date; anything else by its stored name. */
export function menuDisplayName(menu: Menu): string {
  if (!menu.menuDate) return menu.name
  try {
    return format(parseISO(menu.menuDate), 'EEE, dd.MM.yyyy', { locale: de })
  } catch {
    return menu.name
  }
}
